import { LogoDarkIcon, LogoIcon } from "@/assets/images/base64/images.base64"
import { networkAtom } from "@/atoms/settings"
import navbarLinks from "@/constants/navbarLinks"
import useTheme from "@/hooks/useTheme"
import useTrans from "@/hooks/useTrans"
import { IS_MAINNET } from "@/utils/constants"
import CloseIcon from "@mui/icons-material/Close"
import {
  AppBar,
  Box,
  Chip,
  Container,
  Divider,
  Drawer,
  IconButton,
  Link,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"
import { useAtomValue } from "jotai"
import Image from "next/image"
import NextLink from "next/link"
import { useSearchParams } from "next/navigation"
import { useRouter } from "next/router"
import LanguageMenu from "../language"
import * as styles from "./styles"

interface DrawerViewProps {
  isDrawerOpen: boolean
  setIsDrawerOpen: any
}

const DrawerView = ({ isDrawerOpen, setIsDrawerOpen }: DrawerViewProps) => {
  const trans = useTrans()
  const router = useRouter()
  const { theme } = useTheme()
  const searchParams = useSearchParams()
  const network = useAtomValue(networkAtom)

  const isRenecNetwork = network === BlockchainNetwork.RENEC

  const handlerRedirectToPage = (path: string) => {
    const currentSearchParams = new URLSearchParams(Array.from(searchParams.entries()))
    const currentSearchParamsString = currentSearchParams.toString()
    const query = currentSearchParamsString ? `?${currentSearchParamsString}` : ""
    router.push(`${path}${query}`)
    setIsDrawerOpen(false)
  }

  return (
    <Drawer
      PaperProps={{
        sx: { width: "100%" },
      }}
      open={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction='column' spacing={1} sx={{ flexGrow: 1 }}>
          <AppBar position='static' color='transparent'>
            <Container maxWidth='lg'>
              <Toolbar disableGutters>
                <Stack direction='row' spacing={1} sx={{ flexGrow: 1 }}>
                  <Box
                    sx={{ display: "flex", gap: 2, alignItems: "end" }}
                    onClick={() => handlerRedirectToPage(navbarLinks.home)}
                  >
                    <Image
                      src={theme === "light" ? LogoIcon : LogoDarkIcon}
                      alt='relend-icon'
                      width={121}
                      height={16}
                    />
                    {/* <Typography sx={styles.textLogoDrawerStyle}>Relend</Typography> */}
                  </Box>
                </Stack>
                <Stack direction='row' spacing={2}>
                  <LanguageMenu />
                  <Divider variant='middle' orientation='vertical' flexItem className='w-[1px] text-neutral-500' />
                  <IconButton
                    edge='start'
                    className='text-neutral-800'
                    aria-label='menu'
                    onClick={() => setIsDrawerOpen(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                </Stack>
              </Toolbar>
            </Container>
          </AppBar>
          <Box
            sx={{
              pt: 2,
              pl: 2,
              pr: 2,
            }}
          >
            <Stack direction='column' spacing={2}>
              <Box onClick={() => handlerRedirectToPage(navbarLinks.dashboard)}>
                <Typography
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {trans.header.dashboard}
                </Typography>
              </Box>
              {/*  <Divider
                style={{
                  width: "100%",
                  backgroundColor: "#68626A",
                }}
              />
              <Box onClick={() => handlerRedirectToPage(navbarLinks.liquidations)}>
                <Typography
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {trans.header.liquidations}
                </Typography>
              </Box>
              <Divider
                style={{
                  width: "100%",
                  backgroundColor: "#68626A",
                }}
              /> */}
              <Box onClick={() => handlerRedirectToPage(navbarLinks.staking)}>
                <Typography
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {trans.header.staking}
                </Typography>
              </Box>
              <Box onClick={() => handlerRedirectToPage(navbarLinks.referral)}>
                <Typography
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {trans.header.referral}
                </Typography>
              </Box>
              {isRenecNetwork ? (
                <Box onClick={() => handlerRedirectToPage(navbarLinks.liquidations)}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                    }}
                  >
                    {trans.header.liquidations}
                  </Typography>
                </Box>
              ) : null}
              <Link underline='none' component={NextLink} target='_blank' href={navbarLinks.docs}>
                <Typography
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {trans.header.docs}
                </Typography>
              </Link>
            </Stack>
          </Box>
        </Stack>

        <Stack
          direction='column'
          spacing={2}
          sx={{
            alignItems: "center",
            mb: 2,
          }}
        >
          <Stack spacing={1} flexDirection='column' alignItems='center'>
            <Typography sx={styles.textLogoDrawerStyle} onClick={() => handlerRedirectToPage(navbarLinks.dashboard)}>
              RENEC Lend
            </Typography>
            <Chip
              variant='outlined'
              label={IS_MAINNET ? "Mainnet" : "Testnet"}
              color='primary'
              sx={{ fontSize: 14, fontWeight: "bold" }}
            />
            <Typography>{trans.base.relend_all_rights_reserved}</Typography>
          </Stack>
        </Stack>
      </Box>
    </Drawer>
  )
}

export default DrawerView
